import type { FC } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  Box
} from '@material-ui/core';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';

interface SuccessDialogProps {
  message: string;
  onCancel: () => void;
  open: boolean;
  title: string;
  addInfo: string;
}

export const SuccessDialog: FC<SuccessDialogProps> = (props) => {
  const { message, addInfo, onCancel, open, title, ...other } = props;

  return (
    <Dialog
      onClose={onCancel}
      open={open}
      PaperProps={{
        sx: {
          width: '100%'
        }
      }}
      {...other}
    >
      <Box
        sx={{ textAlign: 'center', mt: 2 }}
      >
        <CheckCircleOutlineRoundedIcon
          color="success"
          fontSize="large"
          sx={{ fontSize: '100px' }}
        />

        <DialogTitle>
          <Typography
            color="inherit"
            sx={{ ml: 2 }}
            variant="inherit"
          >
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography
            color="textPrimary"
            variant="body1"
          >
            {message}
          </Typography>
          <Typography
            color="textPrimary"
            variant="h6"
          >
            {addInfo}
          </Typography>
        </DialogContent>
      </Box>
      <DialogActions>
        <Button
          color="primary"
          onClick={onCancel}
          variant="text"
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};

SuccessDialog.defaultProps = {
  open: false
};

SuccessDialog.propTypes = {
  message: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  addInfo: PropTypes.string,
};
